import { render, staticRenderFns } from "./DesignerDetailLinkPage.vue?vue&type=template&id=78bcf13b&scoped=true"
import script from "./DesignerDetailLinkPage.vue?vue&type=script&lang=js"
export * from "./DesignerDetailLinkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bcf13b",
  null
  
)

export default component.exports